import React, { useEffect, useRef, useState } from "react";
import userService from "../../../../services/user.service";
import moment from "moment";
import { getFromLocalStorage } from "../../../../utils/webStorage";
import { FiChevronsRight } from "react-icons/fi";
import { CircularProgress, Paper } from "@mui/material";
import {
  openConfirmationPopup,
  openSuccessPopup,
  openVideoPopup,
} from "../../../../Redux/Actions/PopupActions";
import { useDispatch, useSelector } from "react-redux";
import {
  restoreDeletedVideos,
  selectUnselectVideoFromStorageManagement,
  setDeletedVideos,
  setSearchedVideos,
  unSelectAllVideoFromStorageManagement,
} from "../../../../Redux/Actions/StorageManagementActions";
import CustomSearch2 from "../../../../Common/CustomSearch2";
import { Checkbox } from "@mui/material";
import { BsCircle, BsFillCheckCircleFill } from "react-icons/bs";

const DeletedVideo = ({ getStorageDetails }) => {
  const windowWidth = useRef(window.innerWidth);
  const userId = getFromLocalStorage("currentUserId");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedRecord, setSearchedRecord] = useState(false);
  const [recordNotFound, setRecordNotFound] = useState(false);
  const reduxPageState = useSelector(
    (state) => state.storageManagementData?.pageState
  );

  const reduxSearchState = useSelector(
    (state) => state.storageManagementData?.searchState
  );

  const deletedVideos = useSelector(
    (state) => state.storageManagementData?.deletedVideosList
  );
  const loading = useSelector((state) => state.storageManagementData?.loading);
  const searchedVideos = useSelector(
    (state) => state.storageManagementData?.searchedVideos
  );
  const selectedVideosArray = useSelector(
    (state) => state.storageManagementData?.selectedVideos
  );
  const dispatch = useDispatch();
  const listInnerRef = useRef();

  useEffect(() => {
    unSelectAllVideoFromStorageManagement(dispatch, {});
    checkWidthOfScreen(true);
  }, []);

  const checkWidthOfScreen = () => {
    setDeletedVideos(dispatch, {
      reduxPageState,
      pageSize: getPageSizeBasedOnScreenWidth(),
      userId,
      page: 0,
      isVideoRestored: true,
    });
  };

  const getPageSizeBasedOnScreenWidth = () => {
    if (windowWidth.current <= 2780 && windowWidth.current > 2680) {
      return 40;
    } else if (windowWidth.current <= 2680 && windowWidth.current > 2370) {
      return 35;
    } else if (windowWidth.current <= 2370 && windowWidth.current > 2000) {
      return 30;
    } else if (windowWidth.current <= 2000 && windowWidth.current > 1895) {
      return 25;
    } else if (windowWidth.current <= 1895 && windowWidth.current > 1600) {
      return 20;
    } else if (windowWidth.current <= 1600 && windowWidth.current >= 1380) {
      return 15;
    } else if (windowWidth.current < 1380) {
      return 10;
    }
  };

  const days = (date_1, date_2) => {
    const date1 = new Date(date_1);
    const date2 = new Date(date_2);
    const time = Math.abs(date2 - date1);
    let TotalDays = Math.ceil(time / (1000 * 60 * 60 * 24));
    return 60 - TotalDays;
  };

  const restoredMedia = () => {
    let videoIds = selectedVideosArray?.map((video) => video.id);
    restoreDeletedVideos(dispatch, {
      videoIds,
      userId,
      pageSize: getPageSizeBasedOnScreenWidth(),
      isRecordSearched: reduxSearchState?.isRecordSearched ? true : false,
      searchQuery,
    });
  };

  const onScroll = () => {
    if (checkPageState().page != checkPageState().total - 1 && !loading) {
      if (listInnerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
        if (Math.round(scrollTop + clientHeight + 1) >= scrollHeight) {
          if (!reduxSearchState?.isRecordSearched) {
            setDeletedVideos(dispatch, {
              reduxPageState,
              pageSize: getPageSizeBasedOnScreenWidth(),
              userId,
              page: reduxPageState.page + 1,
              isVideoRestored: false,
            });
          } else {
            setSearchedVideos(dispatch, {
              userId,
              searchString: searchQuery,
              page: reduxSearchState.page + 1,
              pageSize: getPageSizeBasedOnScreenWidth(),
              isVideoRestored: false,
              searchedRecord: true,
            });
          }
        }
      }
    }
  };

  const checkPageState = () => {
    return reduxSearchState?.isRecordSearched
      ? reduxSearchState
      : reduxPageState;
  };

  const checkSelect = (item) => {
    var i;
    for (i = 0; i < selectedVideosArray?.length; i++) {
      if (selectedVideosArray[i].id === item.id) {
        return true;
      }
    }
    return false;
  };

  const searchvideo = () => {
    setSearchedVideos(dispatch, {
      userId,
      searchString: searchQuery,
      page: 0,
      pageSize: getPageSizeBasedOnScreenWidth(),
      isVideoRestored: true,
      searchedRecord: true,
    });
  };

  const handleDelete = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        videoIds: selectedVideosArray.map((video) => video.id),
        userId: userId,
        page: 0,
        pageSize: getPageSizeBasedOnScreenWidth(),
        open: true,
        message: "Are You Sure You Want To Delete This Video?",
        btnColor: "red",
        btnText: "Delete",
        type: "Delete Video From Storage Management",
        searchQuery,
        isRecordSearched: reduxSearchState?.isRecordSearched ? true : false,
      },
    });
  };

  const getOptions = () => {
    return reduxSearchState?.isRecordSearched ? searchedVideos : deletedVideos;
  };

  return (
    <Paper className="deleted-video-grid-item">
      <div className="d-flex-space-between light-grey-border-bottom">
        <h1 className="storage-title bold">Deleted Video</h1>
        <div className="d-flex-align-cent gap-10 mg-right-10">
          <button
            className={`common-btn green ${
              !selectedVideosArray?.length && "disabled"
            }`}
            disabled={!selectedVideosArray?.length}
            onClick={() => restoredMedia()}
          >
            Restore
          </button>
          <button
            className={`common-btn red ${
              !selectedVideosArray?.length && "disabled"
            }`}
            disabled={!selectedVideosArray?.length}
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
        <div className="storage-management-search-in-header">
          {deletedVideos && (
            <CustomSearch2
              searchQuery={searchQuery}
              searchedRecord={reduxSearchState?.isRecordSearched}
              setSearchedRecord={setSearchedRecord}
              setSearchQuery={setSearchQuery}
              getDataByPage={checkWidthOfScreen}
              searchData={searchvideo}
              pageState={reduxPageState}
              setRecordNotFound={setRecordNotFound}
            />
          )}
        </div>
      </div>
      <div className="storage-management-search-in-container">
        {deletedVideos && (
          <CustomSearch2
            searchQuery={searchQuery}
            searchedRecord={reduxSearchState?.isRecordSearched}
            setSearchedRecord={setSearchedRecord}
            setSearchQuery={setSearchQuery}
            getDataByPage={checkWidthOfScreen}
            searchData={searchvideo}
            pageState={reduxPageState}
            setRecordNotFound={setRecordNotFound}
          />
        )}
      </div>
      <div ref={listInnerRef} className="deleted-box" onScroll={onScroll}>
        <div className="m-2 grid-container">
          {!loading &&
            getOptions()?.map((media, index) => (
              <div className="grid-columns2">
                <div className="d-flex-align-cent gap-10">
                  <div key={index} className="d-flex-align-cent gap-10">
                    <Checkbox
                      onChange={(e) => {
                        selectUnselectVideoFromStorageManagement(dispatch, {
                          checked: e.target.checked,
                          item: media,
                        });
                      }}
                      icon={<BsCircle fontSize="20px" color="#13005A" />}
                      checkedIcon={
                        <BsFillCheckCircleFill
                          fontSize="20px"
                          color="#13005A"
                        />
                      }
                      checked={checkSelect(media)}
                      className="videolibrary-checkbox-icon"
                      style={{ zIndex: "-100 !important" }}
                    />
                    <video
                      src={media.videoPath}
                      className="videoImg cp"
                      onClick={() =>
                        openVideoPopup(dispatch, {
                          status: true,
                          videoURL: media.videoPath,
                        })
                      }
                    />
                  </div>
                  <div className="oflow-hidden w-100">
                    <p className="text-width-auto fs-16">
                      {media.eventMediaCategory}
                    </p>
                    <p className="text-warning text-width-auto">
                      {days(
                        moment(media.updatedAt).format("MM/DD/YYYY"),
                        moment(new Date()).format("MM/DD/YYYY")
                      )}{" "}
                      days left!
                    </p>
                  </div>
                </div>
              </div>
            ))}
          {!loading && getOptions()?.length <= 0 && (
            <div class="d-flex justify-content-center mt-5">
              <h5>No Deleted Media Available</h5>
            </div>
          )}
          {loading && (
            <div class="proggresshght">
              <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                <CircularProgress
                  className="rounded-circle"
                  color="success"
                  sx={{ fontSize: 10, color: "#002244" }}
                  disableShrink
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </Paper>
  );
};

export default DeletedVideo;
